import { useAtomValue } from "jotai"
import Script from "next/script"
import { trackingPreferencesAtom } from "app/state"
import { useEffect } from "react"
import * as Fathom from "fathom-client"
import { usePathname } from "next/navigation"
const GA_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS

const TrackingScripts = () => {
  const preferences = useAtomValue(trackingPreferencesAtom)
  const pathname = usePathname()

  useEffect(() => {
    const fathomId = process.env.FATHOM_ID
    if (fathomId) {
      Fathom.load(fathomId, { auto: false })
    }
  }, [])

  useEffect(() => {
    if (!pathname) return
    Fathom.trackPageview({
      url: pathname.split("?")[0],
      referrer: document.referrer,
    })
  }, [pathname])

  return (
    <>
      {/* The user can turn off Google Analytics from the cookie-policy page */}
      {(preferences?.analytics === undefined || preferences?.analytics) && GA_ID && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
            strategy="lazyOnload"
          />
          <Script id="google-analytics" strategy="lazyOnload">
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${GA_ID}', {
                page_path: window.location.pathname,
              });
            `}
          </Script>
        </>
      )}
    </>
  )
}

export default TrackingScripts
